import { FC } from 'react'

type Props = {
  alt: string
  src: string
  desc: string
}

const Component: FC<Props> = ({ alt, src, desc }) => {
  return (
    <div className="flex flex-col items-center gap-4">
      <div className="text-lg font-bold text-secondary-700 border-b border-1 border-divided">{desc}</div>
      <div className="h-[80px] flex items-center">
        <img src={src} alt={alt} className="object-contain" />
      </div>
    </div>
  )
}

export default Component
